
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.872 25.563l.684-4.346h-4.212v-2.824c0-1.188.588-2.35 2.468-2.35h1.943v-3.7a23.553 23.553 0 00-3.42-.292c-3.467 0-5.73 2.085-5.73 5.853v3.313H17.76v4.346h3.843v10.51h4.74v-10.51h3.528z","fill":"#fff"}})])
          )
        }
      }
    